import React, { useEffect } from 'react';

import { Dealer, DealersList } from '../../../../shared/typings/main.d';
import { ManageDealerMapView } from '../ManageDealerMap/ManageDealerMapView';
import { getZipCodeFromCookies } from '../../../../shared/utils/cookies';
import { onVWBasicStepLoadEvent } from '../../../../shared/tagging/tagging-helpers';
import { StyledLayerBodyContainer } from './styles';
import { ZipInputView } from '../ZipInput/ZipInputView';
import { ThemeProvider } from '@vw-marketing/us-components';

export interface ManageDealerLayerViewProps {
  titleKey: string;
  translationHandler: (key: string) => string;
  trackingManager: any;
  authService: any;
  dealersList: DealersList[];
  fetchDealersListByZipCode: (zipCode: string) => Promise<void>;
  getUserLocation: () => Promise<string | null>;
  isLoadingDealers: boolean;
  isLoadingPreferredDealer: boolean;
  noDealersFound?: boolean;
  userPreferredDealer?: Dealer;
  onDealerSelect?: () => void;
  localeCode: string;
  locale: string;
  fetchPreferredDealer: (vehicleId: string, vin: string, newDealerId?: string) => Promise<void>;
  showToast: (message: any, appearance?: any, title?: string) => void;
  userPreferredVehicle: any;
  history: any;
  currentPathname: string;
  baseUrl?: string;
}

export const ManageDealerLayerContentView = ({
  translationHandler,
  trackingManager,
  authService,
  dealersList,
  fetchDealersListByZipCode,
  getUserLocation,
  isLoadingDealers,
  isLoadingPreferredDealer,
  noDealersFound = false,
  userPreferredDealer,
  onDealerSelect,
  localeCode,
  locale,
  fetchPreferredDealer,
  showToast,
  userPreferredVehicle,
  history,
  currentPathname,
  baseUrl
}: ManageDealerLayerViewProps) => {
  useEffect(() => {
    if (dealersList.length === 0) {
      const cookieZip = getZipCodeFromCookies();
      if (cookieZip) {
        fetchDealersListByZipCode(cookieZip);
      }
    }
  }, []);

  useEffect(() => {
    try {
      onVWBasicStepLoadEvent(trackingManager, {
        Name: 'Find a Dealer',
        StepName: 'Find a Dealer Map',
        StepNumber: '3',
      });
    } catch (error) {
      console.warn('Error tracking Find a Dealer step load event:', error);
    }
  }, [trackingManager]);

  return (
    <ThemeProvider theme="main">
      <StyledLayerBodyContainer>
        <ZipInputView
          translationHandler={translationHandler}
          trackingManager={trackingManager}
          fetchDealersListByZipCode={fetchDealersListByZipCode}
          getUserLocation={getUserLocation}
          isLoadingDealers={isLoadingDealers}
          isLoadingPreferredDealer={isLoadingPreferredDealer}
          userPreferredDealer={userPreferredDealer}
          dealersList={dealersList}
          isCanada={localeCode.toUpperCase().endsWith('-CA')}
        />
        <ManageDealerMapView
          authService={authService}
          dealersList={dealersList}
          fetchDealersListByZipCode={fetchDealersListByZipCode}
          userPreferredDealer={userPreferredDealer}
          isLoadingDealers={isLoadingDealers}
          noDealersFound={noDealersFound}
          onDealerSelect={onDealerSelect}
          translationHandler={translationHandler}
          trackingManager={trackingManager}
          localeCode={localeCode}
          locale={locale}
          fetchPreferredDealer={fetchPreferredDealer}
          showToast={showToast}
          userPreferredVehicle={userPreferredVehicle}
          history={history}
          currentPathname={currentPathname}
          baseUrl={baseUrl}
        />
      </StyledLayerBodyContainer>
    </ThemeProvider>
  );
};
